import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from './Tx';
import Text from './Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../maps/data.js';

export default function InstallerDialog(props) {
    const { open, onClose } = props;
    const newUser = !Object.keys(open).length;
    const [name, s_name] = useState(open.name || '');

    const save = async () => {
        await api({
            type: newUser ? 'addInstaller' : 'editInstaller',
            data: {
                name,
                _id: open._id
            }
        });
        onClose();
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newUser ? <Tx>user.addInstaller.title</Tx> : <Tx>user.editInstaller.title</Tx>}
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5 }}>
                    <Text
                        label="installer.name"
                        value={name}
                        onChange={s_name}
                        validators={['required']}
                        errorMessages={['this field is required']} />

                </DialogContent>

                <DialogActions>

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type='submit'>
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </ValidatorForm>
        </Dialog>)
}